import React, { useState, useEffect } from 'react'
import OneColWrapper from '../technical/OneColWrapper'
import WidgetEmbed from '../technical/WidgetEmbed'
import Headline from '../atoms/Headline'

const EmbedBlock = ({ block }) => {
  const [checkedParams, setCheckedParams] = useState(false)

  let queryString = ''
  let utmSource = ''
  let utmMedium = ''
  let utmCampaign = ''
  let utmId = ''
  let utmTerm = ''
  let utmContent = ''

  useEffect(() => {
    if (window !== undefined) {
      queryString = window.location.search

      let urlParams = new URLSearchParams(queryString)
      utmSource = urlParams.get('utm_source')
      utmMedium = urlParams.get('utm_medium')
      utmCampaign = urlParams.get('utm_campaign')
      utmId = urlParams.get('utm_id')
      utmTerm = urlParams.get('utm_term')
      utmContent = urlParams.get('utm_content')
    }
    if (block.code.indexOf('123formbuilder.com') !== -1) {
      block.code = block.code.replace(
        '<script',
        '<script data-custom-vars="control2475360=' +
          utmSource +
          '&control2475361=' +
          utmMedium +
          '&control2475362=' +
          utmCampaign +
          '&control2475363=' +
          utmId +
          '&control2475364=' +
          utmTerm +
          '&control2475365=' +
          utmContent +
          '"'
      )
    }

    setCheckedParams(true)
  }, [])

  return (
    <OneColWrapper
      block={block}
      className={`embed-block ${
        block.headline?.length > 0 ? '' : 'pt-0'
      } embed-block-${block.embed_width}`}
    >
      <Headline
        kicker={block.kicker}
        headline={block.headline}
        headline_level={block.headline_level}
        subheadline={block.subheadline}
      />
      <div
        className={` ${
          block.aspect_ratio && block.aspect_ratio !== 'none'
            ? 'ratio ratio-' + block.aspect_ratio?.replace('by', 'x')
            : ''
        }`}
      >
        {checkedParams && <WidgetEmbed widgetHtml={block.code} />}
      </div>
    </OneColWrapper>
  )
}

export default EmbedBlock
